import { types, applySnapshot } from "mobx-state-tree";
import { Framework } from "@flint/framework";

const EPubModel = types
  .model("EPubModel", {
    epubs: types.array(
      types.model("EPub", {
        id: types.string,
        isbn: types.string,
        title: types.string,
        author: types.string,
        publisher: types.string,
        isDisplay: types.maybeNull(types.boolean),
      })
    ),
  })
  .actions((self) => ({
    fetch() {
      Framework.sendEvent("FETCHING_EPUB_DATA");
    },
    set(response) {
      const epubs = response.data.response;
      // console.log(epubs);
      applySnapshot(self, {
        epubs,
      });
    },
  }));

export default EPubModel;